import ApiCall from "../../../utils/apiCall";
import { setAlertMessage } from "../../../actions";
import { verify } from "../../../actions/index";

// Reducer
export default function reducer(state = {}, action) {
  switch (action.type) {
    case "store.subscriptions.isFetching":
      return { ...state, isFetching: true };

    case "store.subscriptions.fetchSuccess":
      return { ...state, isFetching: false, plans: action.response };

    case "store.subscriptions.fetchError":
      return { ...state, isFetching: false, plans: action.response };

    default:
      return state;
  }
}

// Actions
export function createSubscription(requestPayload, showUpgradeSuccessModal) {
  return (dispatch, getState) => {
    dispatch({ type: "store.subscriptions.isFetching" });

    const { storeId } = getState().settings;

    ApiCall.post(`/stores/${storeId}/subscriptions`, requestPayload)
      .then(response => {
        dispatch({
          type: "store.subscriptions.fetchSuccess",
          response: response.json
        });
        dispatch(verify());
        showUpgradeSuccessModal({ subscriptionId: response.json.id });
      })

      .catch(error => {
        dispatch({ type: "store.subscriptions.fetchError", error });
        dispatch(setAlertMessage(error.json.errors, "error"));
      });
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/store/subscriptions.js